/* eslint-disable @typescript-eslint/ban-types */

import { ControlValueAccessor, NgControl } from '@angular/forms';
import { Self, Optional, Component, Input } from '@angular/core';
import { UserHelper } from '@helpers/user.helper';
import { UiHelper } from '@helpers/ui.helper';
import { ApiService } from '@services/api.service';

@Component({
  selector: 'FileUpload',
  template: `
    <div [class]="mainClass + ' ' + extraClass">
      <div class="labelInput-container">
        <label for="fID" *ngIf="labelText">{{ labelText }}</label>
        <button class="btn fileUpload-button" (click)="fileInput.click()">
          <div class="btn-text">{{ defaultText }}</div>
        </button>
        <input #fileInput hidden type="file" [id]="id" [name]="fID" multiple (change)="onFileInput($event)" [required]="isRequired" [disabled]="disabled" />
      </div>
      <div class="control-text" *ngIf="fileControlText">
        {{ fileControlText }}
      </div>
      <div *ngIf="file && file.length > 0" class="upload-file-size">
        <div *ngFor="let item of file">
          <div class="upload-error-container {{ item.errorControl.sizeControl !== '' || item.errorControl.fileTypeControl !== '' ? 'upload-file-size-error' : '' }}">
            <div>{{ item.name }}</div>
            <div>{{ item.errorControl.sizeControl }}</div>
            <div>{{ item.errorControl.fileTypeControl }}</div>
          </div>
        </div>
      </div>
    </div>
  `,
})
export class FileUpload implements ControlValueAccessor {
  constructor(@Self() @Optional() public control: NgControl, private _UserHelper: UserHelper, private _ApiService: ApiService, private _UiHelper: UiHelper) {
    this.control && (control.valueAccessor = this);
  }

  file: any[] = [];

  @Input()
  mainClass = '';
  @Input()
  acceptType = [];
  @Input()
  maxSizeText = '';
  @Input()
  fileTypeText = '';
  @Input()
  fileControlText = '';
  @Input()
  defaultText = '';
  @Input()
  labelText = '';
  @Input()
  disabled = false;
  @Input()
  isRequired = false;
  @Input()
  extraClass = '';
  @Input()
  id = '';
  @Input()
  fID = '';
  @Input()
  IsMultiple = false;
  @Input()
  fileSizeType = '';
  @Input()
  maxSize = '';
  @Input()
  apiFunc: Function;
  private errorMessages = new Map<string, () => string>();
  formValue: any;
  public get invalid(): boolean {
    return this.control ? this.control.invalid : false;
  }

  public get showError(): boolean {
    if (!this.control) {
      return false;
    }

    const { dirty, touched } = this.control;

    return this.invalid ? dirty || touched : false;
  }

  public get errors(): Array<string> {
    if (!this.control) {
      return [];
    }

    const { errors } = this.control;
    return Object.keys(errors).map(key => (this.errorMessages.has(key) ? this.errorMessages.get(key)() : <string>errors[key] || key));
  }

  returnFileSize = (number: number): boolean => {
    if (this.fileSizeType === 'B') {
      return number > Number(this.maxSize);
    } else if (this.fileSizeType === 'KB') {
      return Math.floor(number / 1024) > Number(this.maxSize);
    } else if (this.fileSizeType === 'MB') {
      return Math.floor(number / 1048576) > Number(this.maxSize);
    }
  };

  returnFileType = (type: string): boolean => {
    return !this.acceptType.includes(type);
  };

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onChanged = formValue => {};

  // eslint-disable-next-line @typescript-eslint/no-empty-function
  onTouched = () => {};

  writeValue(value: any): void {
    this.formValue = value;
    this.onChanged(this.formValue);
  }

  registerOnChange(onChange: any): void {
    this.onChanged = onChange;
  }

  registerOnTouched(onTouched: any): void {
    this.onTouched = onTouched;
  }

  onFileInput(files: any): void {
    if (files) {
      this.file = [];
      for (let i = 0; i < files.target.files.length; i++) {
        this.file.push({
          name: files.target.files[i].name,
          size: files.target.files[i].size,
          lastModified: files.target.files[i].lastModified,
          lastModifiedDate: files.target.files[i].lastModifiedDate,
          type: files.target.files[i].type,
          errorControl: {
            sizeControl: this.returnFileSize(files.target.files[i].size) ? this.maxSizeText : '',
            fileTypeControl: this.returnFileType(files.target.files[i].type) ? this.fileTypeText : '',
          },
        });
      }
      this.apiFunc(files.target.files);
    }
  }
}
